import { SalesRetail } from 'commons/types/DTO/bank/quarterlyReport/bankAccount/SalesRetail'
import { Link } from 'ui/components'

export const renderLicensesList = (sales: SalesRetail) =>
  sales.licenses.map((license, i) => (
    <span key={i}>
      {license.id !== 0 ? (
        <Link to="/licenses/$licenseId" params={{ licenseId: license.id.toString() }}>
          {license.licenseNumber}
        </Link>
      ) : (
        <>{license.licenseNumber}</>
      )}
      {i === sales.licenses.length - 1 ? '' : ', '}
    </span>
  ))
